import i18next from 'i18next';

i18next.addResources('es', 'checkbox', {
  check: 'comprobado'
});

i18next.addResources('en', 'checkbox', {
  check: 'checked'
});

i18next.addResources('pt', 'checkbox', {
  check: 'marcado'
});
